import {getAppConfigSetting} from "../utils";

export const ROUTER_BASENAME = "";
export const LEGIT_SERVICE_CONFIG = {
  useSessionLogin: false,
  apiUrl: getAppConfigSetting('apiUrl'),
};
export const ALL_REQUESTED_PERMISSIONS = ["account.read"];
export const OKTA_DOMAIN = getAppConfigSetting('oktaUrl');
export const CLIENT_ID = getAppConfigSetting('clientId');
export const CALLBACK_PATH = "/implicit/callback";

export const ISSUER = getAppConfigSetting('oktaIssuer');
export const HOST = window.location.href;
export const REDIRECT_URI = HOST;
export const SCOPES = "openid profile email";

export const OKTA_CONFIG = {
    issuer: ISSUER,
    clientId: CLIENT_ID,
    redirectUri: REDIRECT_URI,
    scopes: SCOPES.split(/\s+/),
    pkce: true
};
